export const GET_ALL_MAINTENANCE_TYPE = "GET_ALL_MAINTENANCE_TYPE";
export const GET_MAINTENANCE_TYPE = "GET_MAINTENANCE_TYPE";
export const GET_MAINTENANCE_SUB_TYPE = "GET_MAINTENANCE_SUB_TYPE";
export const GET_PUBLIC_HOLIDAYS = "GET_PUBLIC_HOLIDAYS";
export const GET_OPERATING_HOURS = "GET_OPERATING_HOURS";



